import { render } from "./FullSearcher.vue?vue&type=template&id=36c98528"
import script from "./FullSearcher.vue?vue&type=script&lang=js"
export * from "./FullSearcher.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__